<template>
  <div class="tw-rounded-full tw-w-56 tw-h-56 tw-block tw-bg-cover tw-bg-center tw-cursor-pointer" :style="{ 'background-image': `url(${imageData})` }" @click="chooseImage">
    <span
      v-if="!imageData"
      class="tw-rounded-full tw-flex tw-justify-center tw-items-center tw-bg-gray-100 hover:tw-bg-gray-200 tw-w-full tw-h-full tw-border tw-border-primary-500 tw-border-dashed tw-text-primary-500"
    >
      Select Image
    </span>
    <input class="tw-rounded-full tw-hidden" ref="fileInput" type="file" accept="image/jpeg, image/png" @input="onSelectFile" />
  </div>
</template>

<script>
export default {
  name: "ImageInput",
  data() {
    return {
      imageData: null,
    };
  },
  methods: {
    chooseImage() {
      this.$refs.fileInput.click();
    },
    onSelectFile() {
      var input = this.$refs.fileInput;
      var files = input.files;
      if (files && files[0]) {
        var reader = new FileReader();
        reader.onload = (e) => {
          this.imageData = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
  },
};
</script>
